module.exports = __webpack_public_path__ + "img/footer-logo.0b9bdb34.png";